// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistic2-add-existing-report-description {
  margin-bottom: 32px;
}

::ng-deep mat-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/statistic2/statistic2-header/statistic2-add-existing-report-dialog/statistic2-add-existing-report-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ","sourcesContent":[".statistic2-add-existing-report-description {\r\n    margin-bottom: 32px;\r\n}\r\n\r\n::ng-deep mat-form-field {\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
